import { render, staticRenderFns } from "./MultiUpload.vue?vue&type=template&id=36a6a856&"
import script from "./MultiUpload.vue?vue&type=script&lang=js&"
export * from "./MultiUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports